export default __webpack_public_path__ + "static/media/general-setting-icon.0e1d8aec.png";